import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Groups, Group, CreateGroup, UpdateGroup } from "./pages";

export const GroupsRouter = [
  <Route
    path="/groups"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Groups />
      </ProtectedRoute>
    }
  />,

  <Route path="/group">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateGroup />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Group />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateGroup />
        </ProtectedRoute>
      }
    />
  </Route>,
];
